import cn from 'classnames'

import { useCurrency } from '../../../../../utils/use-currency'
import { useRateInfo } from '../../../wallets/info/components/chart/use/useRateInfo'
import { DAY } from '../../../wallets/info/wallet.constants'

import { countDecimalPlaces } from '../../../../../utils/count-decimal-places'

import { floorNumber } from '../../../../../utils/floor-number'

import { formatNumberWithSpaces } from '../../../../../utils/format-number-with-spaces'

import styles from './styles.module.scss'
import { IDashboardTableViewItemProps } from './dashboard-table-view-item.props'
import { useTranslation } from 'utils/use-translation'

export default function DashboardTableViewItem({
  wallet,
  totalWalletBalance,
  index,
  indicatorStyleName,
  otherBalance,
  otherPercent,
}: IDashboardTableViewItemProps) {
  const { t } = useTranslation()

  const currencyInfo = useCurrency({
    code: wallet.code,
    network: wallet.network,
  })
  const { actualRate, changeValue } = useRateInfo({ currency: currencyInfo, period: DAY, isDashboard: true })

  return index !== 3 ? (
    <>
      <div className={styles.row}>
        <div className={styles.wallet}>
          <div className={cn(styles.indicator, styles[indicatorStyleName])}></div>
          <p className={styles.oneLine}>
            {wallet.code.toUpperCase()} ({wallet.network.toUpperCase()})
          </p>
        </div>
        <p>
          {countDecimalPlaces(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100) > 2
            ? formatNumberWithSpaces(+(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100).toFixed(2))
            : formatNumberWithSpaces(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100)}
          %
        </p>

        <p>
          $
          {countDecimalPlaces(wallet.balance * +wallet.rate) > 2
            ? formatNumberWithSpaces(floorNumber(+(wallet.balance * +wallet.rate), 2))
            : formatNumberWithSpaces(wallet.balance * +wallet.rate)}
        </p>

        <p className={changeValue?.type === 'INCREASE' ? styles.green : styles.red}>
          {changeValue ? (changeValue.type === 'INCREASE' ? '↑' : '↓') : ''}
          {changeValue ? '$' : ''}
          {changeValue?.value}
        </p>

        <p>
          $
          {countDecimalPlaces(+wallet.rate) > 2
            ? formatNumberWithSpaces(parseFloat(floorNumber(+wallet.rate, 2).toString()))
            : formatNumberWithSpaces(parseFloat(wallet.rate))}
        </p>
      </div>

      <div className={styles.row_mobile}>
        <div className={styles.headers}>
          <h5>{t('portfolio')}</h5>
          <h5>{t('balance')}</h5>
          <h5>{t('rate')}</h5>
        </div>

        <div className={styles.line}></div>

        <div className={styles.data}>
          <div className={styles.data__item}>
            <div className={styles.coin}>
              <div className={cn(styles.indicator, styles[indicatorStyleName])}></div>
              <p className={styles.coin__name}>{wallet.code.toUpperCase()} ({wallet.network.toUpperCase()})</p>
            </div>

            <p className={styles.percent}>
              {countDecimalPlaces(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100) > 2
                ? formatNumberWithSpaces(+(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100).toFixed(2))
                : formatNumberWithSpaces(((wallet.balance * +wallet.rate) / totalWalletBalance) * 100)}
              %
            </p>
          </div>

          <div className={styles.data__item}>
            <p className={styles.balance}>
              $
              {countDecimalPlaces(wallet.balance * +wallet.rate) > 2
                ? formatNumberWithSpaces(floorNumber(wallet.balance * +wallet.rate, 2))
                : formatNumberWithSpaces(wallet.balance * +wallet.rate)}
            </p>
          </div>

          <div className={styles.data__item}>
            <p className={styles.balance}>
              $
              {countDecimalPlaces(+wallet.rate) > 2
                ? formatNumberWithSpaces(parseFloat(floorNumber(+wallet.rate, 2).toString()))
                : formatNumberWithSpaces(parseFloat(wallet.rate))}
            </p>

            {changeValue && actualRate && (
              <p className={changeValue.type === 'INCREASE' ? styles.green : styles.red}>
                {changeValue.type === 'INCREASE' ? '↑' : '↓'}${changeValue.value}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  ) : (
    <>
      <div className={styles.row}>
        <div className={styles.wallet}>
          <div className={cn(styles.indicator, styles[indicatorStyleName])}></div>
          <p>{t('other')}</p>
        </div>
        <p>{otherPercent}%</p>
        <p>${formatNumberWithSpaces(otherBalance)}</p>
      </div>

      <div className={styles.row_mobile}>
        <div className={styles.headers}>
          <h5>{t('portfolio')}</h5>
          <h5>{t('balance')}</h5>
        </div>

        <div className={styles.line}></div>

        <div className={styles.data}>
          <div className={styles.data__item}>
            <div className={styles.coin}>
              <div className={cn(styles.indicator, styles[indicatorStyleName])}></div>
              <p className={styles.coin__name}>{t('other')}</p>
            </div>

            <p className={styles.percent}>{otherPercent}%</p>
          </div>

          <div className={styles.data__item}>
            <p className={styles.balance}>${formatNumberWithSpaces(otherBalance)}</p>
          </div>
        </div>
      </div>
    </>
  )
}
